export const IN_VIEW_ATTRIBUTE = 'data-event-in-view';
export const inViewEventAttributes = () => ({
    [IN_VIEW_ATTRIBUTE]: true,
});
//# sourceMappingURL=inViewEventAttributes.js.map